import { type ThemaFromThemaRouter } from '../dtos';

export const isAblaufTemplateMissing = (thema: Pick<ThemaFromThemaRouter, 'planungsinformation'>): boolean =>
  !thema.planungsinformation?.zeitlicherAblauf?.length;
